import { formatDate } from '@angular/common';
import { LOCALE_ID, inject } from '@angular/core';

export function formErrorsFactory() {
  const locale = inject(LOCALE_ID);

  return {
    required: $localize`This field is required.`,
    number: $localize`This is not a valid number.`,
    dateFormat: $localize`Wrong date or date format.`,
    minDate: (error: { min: Date }) =>
      $localize`Minimum date is ${formatDate(error.min, 'shortDate', locale)}.`,
    maxDate: (error: { max: Date }) =>
      $localize`Maximum date is ${formatDate(error.max, 'shortDate', locale)}.`,
    min: (error: { min: number }) => $localize`Minimum value is ${error.min}.`,
    max: (error: { max: number }) => $localize`Maximum value is ${error.max}.`,
    minlength: (error: { requiredLength: number }) =>
      $localize`Minimum value length should be ${error.requiredLength}.`,
    maxlength: (error: { requiredLength: number }) =>
      $localize`Maximum value length should be ${error.requiredLength}.`,
    dateRangeInvalid: $localize`From/Start date must be before To/End date.`,
    hasDuplicates: $localize`Duplicate value exists.`,
    email: $localize`E-mail address is not valid.`,
    iban: $localize`Wrong IBAN number.`,
    bankAccountNumber: $localize`Wrong bank account number.`,
    invalidPhoneCharacters: $localize`Invalid characters (only +, 0-9, - and space allowed).`,
    plusAsFirstCharacter: $localize`Plus sign may only be used as the first character.`,
    beginWithPlusOrDigit: $localize`Must begin with + or a digit.`,
    secondCharacterDigit: $localize`The second character must be a digit.`,
    spaceOrDash: $localize`Use either space or dash as a separator.`,
    max4Separators: $localize`Max 4 space/dash separators allowed.`,
    atLeast5Digits: $localize`Must have at least 5 digits (4 if you begin with +).`,
    atLeastOneRequired: $localize`At least one field is required.`,
    nationalId: $localize`This is not a valid national ID.`,
    dNumber: $localize`This is not a valid d-number.`,
    overlappingDates: $localize`Periods can not overlap.`,
    overlappingPositionDates: $localize`Position periods can not overlap.`,
    dateBeforePreviousPosition: $localize`Position can start only after previous position start date.`,
    pattern: $localize`This is not a valid pattern.`,
    invalidNameCharacter: $localize`Invalid character used.`,
    followedByOneOtherCharacter: $localize`'.' character can only be followed by one other character.`,
    invalidPensionCompanyDateRange: (error: { fromDate: Date; toDate: Date }) =>
      $localize`Pension company is valid from ${formatDate(error.fromDate, 'shortDate', locale)} to ${formatDate(error.toDate, 'shortDate', locale)}.`,
    invalidKidNumberDigitMismatch: $localize`Invalid KID number (check digit mismatch).`,
    inactiveAtDate: $localize`This value is out of date (inactive).`,
    maxDecimalPlaces: (error: { maxDecimalPlaces: number }) =>
      $localize`Maximum decimal places allowed is ${error.maxDecimalPlaces}.`,
    numberMaxLength: (error: { maxLength: number }) =>
      $localize`Number exceeds maximum length of ${error.maxLength} characters.`,
    numericOnly: $localize`Only numeric characters (0-9) are allowed.`,
    leadingZeros: $localize`Leading zeros are not allowed.`,
    tagNameNotUnique: $localize`This tag name already exists, tag name should be unique.`,
    splitTotalNotHundred: $localize`Split percentages must total 100%.`,
    unsupportedAdditionalInfo: $localize`This paycode contains additional information fields that are not yet supported in this interface. Please use the previous version of Employees to create this transaction. We are working on supporting more additional information fields.`,
    positionNotCoveredByPeriod: (error: { minPositionStart: Date }) =>
      $localize`Position not covered by any employment. Min date: ${formatDate(error.minPositionStart, 'shortDate', locale)}.`,
    carInUse: (error: { fullName: string }) => $localize`Car is in use by ${error.fullName}.`,
    duplicateCostUnits: $localize`Duplicate cost unit values are not allowed.`,
  };
}
